import { host2namespace } from '@/utils'

const getRedirect = (_location: string, query: {
  redirect: string
}) => {
  
  const namespace = host2namespace(_location)
  const defaultPath = namespace ? '/' : '/center'

  const { redirect } = query

  if (redirect && typeof redirect === 'string' && redirect.startsWith('http')) {
    return decodeURIComponent(redirect)
  }

  return redirect ? decodeURIComponent(redirect as string) : defaultPath
}

export default getRedirect